<template>
  <b-modal
    id="create-team-level-modal"
    title="Create Team Level"
    hide-footer
    size="lg"
    no-close-on-backdrop
    @hidden="formData = LEVEL_FORM_SNAPSHOT()"
    @shown="modalOpenHandler"
  >
    <b-form
      novalidate
      @submit.prevent="submitForm"
    >
      <validation-observer ref="formRef">
        <b-row>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name En"
              rules="required"
            >
              <b-form-group
                label="Name En"
                label-for="team-level-name-en"
              >
                <b-form-input
                  id="team-level-name-en"
                  v-model="formData.name.en"
                  placeholder="Name En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Name Ar"
              rules="required"
            >
              <b-form-group
                label="Name Ar"
                label-for="team-level-name-ar"
              >
                <b-form-input
                  id="team-level-name-ar"
                  v-model="formData.name.ar"
                  placeholder="Name Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description En"
              rules="required"
            >
              <b-form-group
                label="Description En"
                label-for="team-level-description-en"
              >
                <b-form-textarea
                  id="team-level-description-en"
                  v-model="formData.description.en"
                  placeholder="description En"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Description Ar"
              rules="required"
            >
              <b-form-group
                label="Description Ar"
                label-for="team-level-description-ar"
              >
                <b-form-textarea
                  id="team-level-description-ar"
                  v-model="formData.description.ar"
                  placeholder="description Ar"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Sort"
              rules="required"
            >
              <b-form-group
                label="Sort"
                label-for="sort"
              >
                <b-form-input
                  id="sort"
                  v-model.number="formData.sort"
                  type="number"
                  placeholder="Sort"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="Number of members"
              rules="required"
            >
              <b-form-group
                label="Number of members"
                label-for="no-of-members"
              >
                <b-form-input
                  id="no-of-members"
                  v-model.number="formData.configuration.numberOfMembers"
                  type="number"
                  placeholder="Number of members"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <ZonesSearch
              label="Zone"
              :placeholder="level ? level.zone : ''"
              @zone-selected="formData.zone = $event"
            />
          </b-col>
          <b-col md="12">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Save</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BRow,
  BFormTextarea,
  BCol,
  BModal,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'

const LEVEL_FORM_SNAPSHOT = () => JSON.parse(JSON.stringify({
  name: {
    ar: null,
    en: null,
  },
  zone: null,
  description: { ar: null, en: null },
  configuration: { numberOfMembers: null },
  sort: null,
}))

export default {
  components: {
    BModal,
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormTextarea,
    BSpinner,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    ZonesSearch,
    BCol,
  },
  props: {
    level: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)

    const formData = ref(LEVEL_FORM_SNAPSHOT())

    const formRef = ref(null)

    const submitForm = async () => {
      if (!formData.value.zone) return
      const res = await formRef.value.validate()
      if (!res) return

      try {
        submitting.value = true
        if (props.level) {
          await axiosIns.patch(`/teams/level/${props.level.id}`, {
            ...formData.value,
          })
        } else {
          await axiosIns.post('/teams/levels', {
            ...formData.value,
          })
          successNotification('Added successfully')
        }
        ctx.emit('refetch')
        ctx.root.$bvModal.hide('create-team-level-modal')
      } catch (err) {
        const errMsg = err?.response?.data?.message
        errorNotification(errMsg || 'An Error Occured')
      } finally {
        submitting.value = false
      }
    }

    const modalOpenHandler = () => {
      if (props.level) {
        formData.value = JSON.parse(JSON.stringify(props.level))
      }
    }

    return {
      submitting,
      formRef,
      submitForm,
      formData,
      modalOpenHandler,
      LEVEL_FORM_SNAPSHOT,
      required,
    }
  },
}
</script>

  <style></style>
